import { TRemoveAllConfirmSetVisible } from '../../actions/removeAllConfirm';

export const REMOVE_ALL_CONFIRM_SET_VISIBLE: TRemoveAllConfirmSetVisible = 'remove_all_confirm/set_visible';
